import { jsx as _jsx } from "react/jsx-runtime";
import { NodeType } from "@reside/forms/dist/templateTypes";
import { useBlockComponentContext, } from "./BlockComponentContext";
/**
 * Please keep the blocks alphabetically ordered.
 */
import { BlockCard } from "./block-card";
import { BlockCollapsible } from "./block-collapsible";
import { BlockColumn } from "./block-column";
import { BlockCompletionChecklist } from "./block-completion-checklist";
import { BlockContinueButton } from "./block-continue-button";
import { BlockFragment } from "./block-fragment";
import { BlockFieldArray } from "./block-field-array";
import { BlockFormControl } from "./block-form-control";
import { BlockImage } from "./block-image";
import { BlockList } from "./block-list";
import { BlockMandatoryVideo } from "./block-mandatory-video";
import { BlockParagraph } from "./block-paragraph";
import { BlockSubtitle } from "./block-subtitle";
import { BlockTableOfContent } from "./block-table-of-content";
import { BlockTitle } from "./block-title";
import { ErrorBoundary } from "../error-boundary";
import { ErrorMessage } from "../error-message";
import { BlockDemographics } from "./block-demographics/BlockDemographics";
export const BlockByType = ({ block, queryVariables, numberOfBlocks, similarResidentsControl, BlockCard, BlockCollapsible, BlockCompletionChecklist, BlockContinueButton, BlockFieldArray, BlockFragment, BlockFormControl, BlockImage, BlockList, BlockMandatoryVideo, BlockParagraph, BlockSubtitle, BlockTableOfContent, BlockTitle, BlockColumn, BlockDemographics, }) => {
    switch (block.type) {
        // Note: Keep the types sorted alphabetically
        case NodeType.CARD:
            return _jsx(BlockCard, { ...block, queryVariables: queryVariables });
        case NodeType.COLLAPSIBLE:
            return _jsx(BlockCollapsible, { ...block, queryVariables: queryVariables });
        case NodeType.COLUMN:
            return _jsx(BlockColumn, { ...block, queryVariables: queryVariables });
        case NodeType.COMPLETION_CHECKLIST:
            return _jsx(BlockCompletionChecklist, { ...block });
        case NodeType.CONTINUE_BUTTON:
            return _jsx(BlockContinueButton, { ...block });
        case NodeType.DEMOGRAPHICS:
            return (_jsx(BlockDemographics, { queryVariables: queryVariables, similarResidentsControl: similarResidentsControl }));
        case NodeType.FIELD_ARRAY:
            return _jsx(BlockFieldArray, { ...block, queryVariables: queryVariables });
        case NodeType.FORM_CONTROL:
            return (_jsx(BlockFormControl, { ...block, queryVariables: queryVariables, numberOfBlocks: numberOfBlocks, similarResidentsControl: similarResidentsControl }));
        case NodeType.FRAGMENT:
            return (_jsx(BlockFragment, { ...block, queryVariables: queryVariables, similarResidentsControl: similarResidentsControl }));
        case NodeType.IMAGE:
            return _jsx(BlockImage, { ...block });
        case NodeType.LIST:
            return _jsx(BlockList, { ...block, queryVariables: queryVariables });
        case NodeType.PARAGRAPH:
            return _jsx(BlockParagraph, { ...block });
        case NodeType.MANDATORY_VIDEO:
            return _jsx(BlockMandatoryVideo, { ...block });
        case NodeType.SUBTITLE:
            return _jsx(BlockSubtitle, { ...block });
        case NodeType.TABLE_OF_CONTENT:
            return _jsx(BlockTableOfContent, { ...block });
        case NodeType.TITLE:
            return _jsx(BlockTitle, { ...block });
        default:
            throw new Error(`Renderer not implemented ${block.type}`);
    }
};
/**
 * The entry component for rendering dynamic form based on JSON Template.
 */
export const BlockField = ({ onCatch, ...props }) => {
    const blockComponents = useBlockComponentContext();
    // Important to check explicit false
    return props.block?.state?.visible === false ? null : (_jsx(ErrorBoundary, { renderError: error => (_jsx(ErrorMessage, { title: "Failed to render JSON block.", message: error.message })), onCatch: onCatch, children: _jsx(BlockByType, { ...blockComponents, ...props }) }));
};
BlockByType.defaultProps = {
    BlockCard,
    BlockCollapsible,
    BlockColumn,
    BlockCompletionChecklist,
    BlockFormControl,
    BlockFragment,
    BlockImage,
    BlockList,
    BlockMandatoryVideo,
    BlockParagraph,
    BlockSubtitle,
    BlockTableOfContent,
    BlockTitle,
    BlockFieldArray,
    BlockContinueButton,
    BlockDemographics,
};
